// Module
var code = "<div class=\"calendar-display-day\"> <span class=\"calendar-rings\"> <span class=\"calendar-ring\"></span> <span class=\"calendar-ring\"></span> </span> <div class=\"calendar-day\">{{calendarDay | date:'d'}}</div> </div>";
// Exports
var _module_exports =code;;
var path = '/views/common/calendar_day.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;